import { ErrorHandler, Injectable } from "@angular/core";
import { Rum } from 'app/rum.service';

@Injectable()
export class CwrErrorHandler implements ErrorHandler {
  constructor(private rum: Rum) {}
  handleError(error: any) {
    this.rum.awsRum?.recordError(error);
  }
}
